export * from './app-sidebar-header.component';



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/components/app-sidebar-header/index.ts